import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const priceCatalogDetailsSchema = baseObjectSchema.extend({
  priceCatalogId: z.string(),
  materialId: z.string(),
  previousPrice: z.number().optional(),
  price: z.number(),
  permitDiscount: z.boolean(),
  maxDiscountPercent: z.number().optional(),
  maxDiscountValue: z.number().optional(),
  includeVat: z.boolean(),
  material: z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
  }),
  priceCatalog: z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
  }),
});

export const getPriceCatalogDetailsSchema = z.array(priceCatalogDetailsSchema);

export type GetPriceCatalogDetailsResponse = z.infer<typeof getPriceCatalogDetailsSchema>;
